import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Backdrop, Box, CircularProgress } from "@mui/material";

import conf from "config-dlm";
import { INIT_USER, useAuth } from "./AuthProvider";
import { useUserServiceSession } from "hooks/user/base";

const ProtectedRoute = ({ children }: { children: any }) => {
  const auth = useAuth();
  const navigate = useNavigate();

  const session = useUserServiceSession();

  useEffect(() => {
    // redirect to signin
    if (session.isError) {
      const currentPath = window.location.pathname + window.location.search;
      localStorage.setItem("GRACE_REDIRECT_URL", currentPath); // store current (redirect) page

      localStorage.removeItem("GRACE_AUTHENTICATED");

      auth.setAuth(false);
      auth.setUser(INIT_USER);

      navigate("/signin");
    }
  }, [session.isError]);

  if (auth.isLoading && auth.isInitial) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer })}
        open={true}
      >
        <CircularProgress color="primary" />
      </Backdrop>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        maxHeight: `calc(100vh - ${conf.HEIGHT.NAVBAR} - ${conf.HEIGHT.FOOTER})`,
      }}
    >
      {children}
    </Box>
  );
};

export default ProtectedRoute;
